<template>
  <form class="medication-dispense-form" @submit.prevent="handleFormSubmit">
    <div class="row">
      <div class="col-6">
        <form-group label="" for-id="medication-reference" :errors="errors">
          <medication-reference-input
            input-id="medication-reference"
            :value="medicationReferenceInputValue"
            :allow-substitution="isSubstitution"
            :labels="true"
            :recommended-commercial-medication="recommendedCommercialMedication"
            :basic-reference="basicReference"
            @input="handleMedicationReferenceInput" />
        </form-group>
        <form-group
          label="Cantidad"
          for-id="medication-quantity-value"
          :errors="errors"
          error-key="quantity">
          <input
            id="medication-quantity-value"
            ref="medicationQuantityValueInput"
            v-model="form.data.quantity.value"
            type="number"
            min="0"
            step=".01"
            class="form-control">
        </form-group>
        <!-- <form-group label="Forma Farmacéutica" for-id="medication-quantity-code">
          <medication-drug-forms-input v-model="form.data.quantity.code" input-id="medication-quantity-code" />
        </form-group> -->
        <form-group label="Sugerencia farmacéutico ">
          <textarea v-model="form.data.note" class="form-control" rows="3" />
        </form-group>
        <div v-if="isSubstitution">
          <form-group label="Dosis" for-id="medication-dose-value">
            <div class="row">
              <div class="col-6">
                <input
                  id="medication-dose-value"
                  v-model="doseAndRateValue"
                  type="number"
                  min="0"
                  class="form-control">
              </div>
              <div class="col-6">
                <medication-drug-forms-input id="medication-dose-code" v-model="doseAndRateCode" />
              </div>
            </div>
          </form-group>
          <form-group label="Cada" for-id="medication-timing-frequency">
            <div class="row">
              <div class="col-6">
                <input
                  id="medication-timing-frequency"
                  v-model="timingFrequency"
                  type="number"
                  min="0"
                  class="form-control">
              </div>
              <div class="col-6">
                <medication-units-of-time-input id="medication-timing-period-unit" v-model="timingPeriodUnit" />
              </div>
            </div>
          </form-group>
          <form-group label="Vía" for-id="medication-route-code">
            <medication-route-codes-input v-model="routeCode" input-id="medication-route-code" />
          </form-group>
          <form-group label="Razón del cambio de medicamento" for-id="substitution-reason" :errors="errors">
            <textarea
              id="substitution-reason"
              v-model="form.data.substitution.reason"
              class="form-control"
              rows="3" />
          </form-group>
        </div>
      </div>
      <div class="col-6">
        <div class="receta-preview">
          <div class="row">
            <div class="col-6">
              <label for="">Nombre paciente</label>
              <div class="value">
                {{ patientName }}
              </div>
            </div>
            <div class="col-3">
              <label for="">{{ runOrPassport }}</label>
              <div class="value">
                {{ getRutPatient }}
              </div>
            </div>
            <div class="col-3">
              <label for="">Edad</label>
              <div class="value">
                {{ patientAge }}
              </div>
            </div>
          </div>
          <div class="row">
            <div :class="runOrPassport == 'RUN' ? 'col-12' : 'col-6'">
              <label for="">Dirección</label>
              <div class="value">
                {{ patientAddress }}
              </div>
            </div>
            <div v-if="runOrPassport != 'RUN'" class="col-6">
              <label for="">País</label>
              <div class="value">
                {{ getCountry }}
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-12">
              <h6>RP (Prescripción)</h6>
              <div class="medication-dispense-form__medicine">
                <div class="medication-dispense-form__medicine_name">
                  {{ medicineName }}
                </div>
                <div class="medication-dispense-form__medicine_content">
                  <div>
                    <label for="">Alternativa comercial</label>
                    <div class="value">
                      {{ alternativeComercialMedicineName.display }}
                    </div>
                  </div>
                  <div>
                    <label>
                      <strong>Administrar:</strong>
                    </label>
                  </div>
                  <div class="row">
                    <div class="col-3">
                      <label for="">Dosis:</label>
                      <div class="value">
                        {{ getDosis }}
                      </div>
                    </div>
                    <div class="col-3">
                      <label for="">Frecuencia:</label>
                      <div class="value">
                        {{ getFrecuencia }}
                      </div>
                    </div>
                    <div class="col-3">
                      <label for="">Vía de administración:</label>
                      <div class="value">
                        {{ getVia }}
                      </div>
                    </div>
                    <div class="col-3">
                      <label for="">Período de tratamiento</label>
                      <div class="value">
                        {{ getPeriod }}
                      </div>
                    </div>
                  </div>
                  <div v-if="dispenseQuantity > 0" class="row">
                    <div class="col-12">
                      <label for="">Cantidad a dispensar</label>
                      <div class="value">
                        {{ dispenseQuantity + ' (' + numeroALetras(dispenseQuantity) + ') ' + (dispenseQuantity > 1 ? 'unidades' : 'unidad') }}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <label for="">Indicación de administración</label>
                      <div class="value">
                        {{ medicineIndications }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>

    <div class="medication-dispense-form__footer d-flex justify-content-center">
      <button class="btn btn-danger" type="submit" :disabled="!isLargerThanZero">
        Confirmar
      </button>
    </div>
  </form>
</template>

<script>
import FormGroup from '@/components/FormGroup';
import MedicationReferenceInput from '@/components/medication/MedicationReferenceInput';
import MedicationDrugFormsInput from '@/components/medication/MedicationDrugFormsInput';
import MedicationUnitsOfTimeInput from '@/components/medication/MedicationUnitsOfTimeInput';
import MedicationDispenseDefinition from '@/fhir-definitions/medication-dispense';
import MedicationRouteCodesInput from '@/components/medication/MedicationRouteCodesInput';
import _set from 'lodash/set';
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import _debounce from 'lodash/debounce';
import uuidv4 from 'uuid/v4';
import moment from 'moment';

import numeroALetras from '@/helpers/numeroLetras';

const MINSAL_API_REFERENCE_URL = process.env.VUE_APP_MINSAL_API_REFERENCE_URL;

export default {
  name: 'MediationDispenseForm',
  components: {
    MedicationRouteCodesInput,
    MedicationDrugFormsInput,
    MedicationUnitsOfTimeInput,
    MedicationReferenceInput,
    FormGroup
  },
  props: {
    medicationRequest: {
      type: Object,
      default: () => {
        return {};
      }
    },
    medicationDispense: {
      type: Object,
      default: () => {
        return {};
      }
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    },
    patient: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        data: this.hasDispenseData ? this.medicationDispense : MedicationDispenseDefinition(this.medicationDispense),
        basicReference: null
      }
    };
  },
  computed: {
    dispenseQuantity() {
      try {
        return parseInt(this.medicationRequest.dispenseRequest.quantity);
      } catch (e) {
        return 0;
      }
    },
    isLargerThanZero() {
      return this.form.data.quantity.value > 0;
    },
    hasDispenseData() {
      return Object.keys(this.medicationDispense).length;
    },
    medicineName() {
      return this.medicationRequest.medicationReference.display;
    },
    alternativeComercialMedicineName() {
      return _get(this.medicationRequest, 'supportingInformation', []).find(s => {
        return s.type === 'Medication' && _get(s, 'category', '') === 'commercial';
      }) || {};
    },
    medicineIndications() {
      return this.medicationRequest.dosageInstruction.text;
    },
    getPeriod() {
      let period = this.medicationRequest.dosageInstruction[0].timing.repeat.boundsDuration;
      return period.value + ' ' + this.getUnit(period.code, period.value);
    },
    getVia() {
      return this.medicationRequest.dosageInstruction[0].route.coding[0].display;
    },
    getFrecuencia() {
      let timing = this.medicationRequest.dosageInstruction[0].timing.repeat;
      return timing.period + ' ' + this.getUnit(timing.periodUnit, timing.period);
    },
    // eslint-disable-next-line complexity
    getDosis() {
      let dose = this.medicationRequest.dosageInstruction[0].doseAndRate[0].doseQuantity;
      let pluralValue = dose.code;
      let doseQuantity = dose.value;
      if (doseQuantity > 1) {
        switch (dose.code) {
          case 'anillo vaginal': pluralValue = 'anillos vaginales'; break;
          case 'cápsula vaginal': pluralValue = 'cápsulas vaginales'; break;
          case 'jeringa prellenada': pluralValue = 'jeringas prellenadas'; break;
          case 'aplicación': pluralValue = 'aplicaciones'; break;
          case 'bidón': pluralValue = 'bidones'; break;
          case 'dosis': pluralValue = 'dosis'; break;
          case 'gotas': pluralValue = 'gotas'; break;
          case 'matraz': pluralValue = 'matraces'; break;
          case 'unidades internacionales': pluralValue = 'unidades internacionales'; break;
          case 'unidades': pluralValue = 'unidades'; break;
          case 'vial': pluralValue = 'viales'; break;
          default: pluralValue = `${dose.code}s`;
        }
      }

      return `${doseQuantity} ${pluralValue}`;
    },
    getRutPatient() {
      let rut = '';
      this.patient.identifier.forEach(iden => {

        let use = this.runOrPassport == 'RUN' ? 'usual' : 'official';

        if (iden.use == use) {
          rut = iden.value;
        }
      });

      return rut;
    },
    patientName() {
      return this.medicationRequest.subject.display;
    },
    patientAge() {
      let years = moment().diff(this.medicationRequest.subject.birthDate, 'years');
      return `${years} años`;
    },
    patientAddress() {
      return `${this.medicationRequest.subject.address.text}, ${this.medicationRequest.subject.address.district}, ${this.medicationRequest.subject.address.state}`;
    },
    isEditing() {
      return this.medicationDispense && Object.keys(this.medicationDispense).length;
    },
    user() {
      return this.$store.getters.user;
    },
    recommendedCommercialMedication() {
      const recommendedCommercialMedication = _get(this.medicationRequest, 'supportingInformation', []).find(s => s.type.toLowerCase() === 'medication');
      if (!recommendedCommercialMedication) {
        return '';
      }
      return recommendedCommercialMedication.reference;
    },
    medicationReferenceInputValue() {
      return {
        dispensableMedication: this.form.data.medicationReference,
        clinicalMedication: this.clinicalMedication,
        commercialMedication: this.commercialMedication
      };
    },
    commercialMedication() {
      return _get(this.form.data, 'supportingInformation', []).find(s => {
        return s.type === 'Medication' && _get(s, 'category', '') === 'commercial';
      }) || {};
    },
    clinicalMedication() {
      return _get(this.form.data, 'supportingInformation', []).find(s => {
        return s.type === 'Medication' && _get(s, 'category', '') === 'clinical';
      }) || {};
    },
    isSubstitution() {
      return this.form.data.substitution.wasSubstituted;
    },
    doseAndRateValue: {
      get() { return _get(this.form.data, 'dosageInstruction[0].doseAndRate[0].doseQuantity.value', 0); },
      set(value) { _set(this.form.data, 'dosageInstruction[0].doseAndRate[0].doseQuantity.value', value); }
    },
    doseAndRateCode: {
      get() { return _get(this.form.data, 'dosageInstruction[0].doseAndRate[0].doseQuantity.code', 0); },
      set(value) { _set(this.form.data, 'dosageInstruction[0].doseAndRate[0].doseQuantity.code', value); }
    },
    routeCode: {
      get() { return _get(this.form.data, 'dosageInstruction[0].route.coding[0].code', 0); },
      set(value) {
        let route = this.$store.getters.routeCodes.find(r => r.code === value);
        _set(this.form.data, 'dosageInstruction[0].route.coding[0].code', route.code);
        _set(this.form.data, 'dosageInstruction[0].route.coding[0].display', route.display);
      }
    },
    timingFrequency: {
      get() { return _get(this.form.data, 'dosageInstruction[0].timing.repeat.frequency', 0); },
      set(value) { _set(this.form.data, 'dosageInstruction[0].timing.repeat.frequency', value); }
    },
    timingPeriodUnit: {
      get() { return _get(this.form.data, 'dosageInstruction[0].timing.repeat.periodUnit', 0); },
      set(value) { _set(this.form.data, 'dosageInstruction[0].timing.repeat.periodUnit', value); }
    },
    runOrPassport() {
      try {
        return this.patient.identifier[0].type.coding[0].code == 'PPN' ? 'Pasaporte'  : 'DNI';
      } catch (e) {
        // Si cae acá, no es extranjero
      }

      return 'RUN';
    },
    getCountry(){
      try {
        return this.patient.identifier[0].type.extension[0].valueCodeableConcept.coding[0].display;
      } catch (e) {
        return 'desconocido';
      }
    }
  },
  watch: {
    isSubstitution(isSubstitution, oldValue) {
      if (!isSubstitution) {
        this.resetMedicationRequestMedication(this.medicationRequest);
      } else {
        this.resetMedications();
      }
    }
  },
  created() {
    if (this.isEditing) {
      this.form.data = _cloneDeep(this.medicationDispense);
    } else {
      this.initializeFromMedicationRequest(_cloneDeep(this.medicationRequest));
    }
  },
  mounted() {
    this.$refs.medicationQuantityValueInput.focus();
  },
  methods: {
    numeroALetras: numeroALetras,
    handleFormSubmit() {
      this.$emit('submit', JSON.parse(JSON.stringify(this.form.data)), this.medicationRequest.id);
    },
    handleMedicationReferenceInput(medicationReferenceInput) {
      this.form.data.medicationReference = _get(medicationReferenceInput, 'dispensableMedication');
      const clinicalMedication = Object.assign(_get(medicationReferenceInput, 'clinicalMedication', {}), { type: 'Medication', category: 'clinical' });
      const commercialMedication = Object.assign(_get(medicationReferenceInput, 'commercialMedication', {}), { type: 'Medication', category: 'commercial' });

      this.form.data.supportingInformation = this.form.data.supportingInformation.filter(d => {
        return d.type !== 'Medication' || !['commercial', 'clinical'].includes(d.category);
      });

      this.form.data.supportingInformation.push(clinicalMedication, commercialMedication);

      if (clinicalMedication.hasOwnProperty('reference')) {
        this.getMedicationDetails(clinicalMedication, 'clinicalMedication');
      }
    },
    initializeFromMedicationRequest(medicationRequest) {
      this.form.data.id = uuidv4();
      this.form.data.authorizingPrescription = {
        reference: `${MINSAL_API_REFERENCE_URL}/medication-requests/${medicationRequest.id}`
      };
      this.form.data.performer = [{
        'actor': {
          'reference': `${MINSAL_API_REFERENCE_URL}/performers/${this.user.claveunica_id}`,
          'display': `${this.user.given_name} ${this.user.family_name}`
        }
      }];
      this.form.data.subject = _get(medicationRequest, 'subject', {});
      this.form.data.medicationReference = {};
      this.form.data.dosageInstruction = _get(medicationRequest, 'dosageInstruction', {});
      this.basicReference = _get(medicationRequest, 'basicReference', null);
      this.form.data.quantity.code = _get(medicationRequest, 'dosageInstruction[0].doseAndRate[0].doseQuantity.code', '');
      this.resetMedicationRequestMedication(medicationRequest);
    },
    resetMedicationRequestMedication(medicationRequest) {
      const clinicalMedication = Object.assign(_get(medicationRequest, 'medicationReference', {}), { type: 'Medication', category: 'clinical' });
      this.form.data.medicationReference = {};
      this.form.data.supportingInformation = this.form.data.supportingInformation.filter(d => {
        return d.type !== 'Medication' || !['commercial', 'clinical'].includes(d.category);
      });
      this.form.data.supportingInformation.push(clinicalMedication);
    },
    resetMedications() {
      this.form.data.medicationReference = {};
      this.form.data.supportingInformation = this.form.data.supportingInformation.filter(d => {
        return d.type !== 'Medication' || !['commercial', 'clinical'].includes(d.category);
      });
    },
    getMedicationDetails: _debounce(function(medication, type) {
      this.$store.dispatch('fetchMedicationDetails', medication)
        .then(response => {
          // Todo: Verificar el formato de dispensación (FFA) y seleccionar el correcto en el formulario
          this.handleMedicationDetailsResponse(response);
        });
    }, 500),
    handleMedicationDetailsResponse(response) {
      // console.log('respuesta: ', response);
    },
    getUnit(unit, value) {
      let timing = value > 1 ? {
        'h': 'horas',
        'd': 'días',
        'min': 'minutos',
        's': 'segundos',
        'wk': 'semanas',
        'm': 'meses',
        'mo': 'meses',
        'a': 'años'
      } : {
        'h': 'hora',
        'd': 'día',
        'min': 'minuto',
        's': 'segundo',
        'wk': 'semana',
        'm': 'mes',
        'mo': 'mes',
        'a': 'año'
      };

      return timing[unit] ? timing[unit] : unit;
    }
  }
};
</script>

<style lang="scss">
.medication-dispense-form {
  &__substitution-toggle {
    margin-bottom: $--spacing-4;
  }

  &__footer {
    > div {
      display: flex;
      justify-content: flex-end;
    }
  }

  &__dialog {
    .el-dialog__body {
      padding-top: $--spacing-2;
    }
  }

  &__medicine{
    border: 1px solid #DAE2EA;
    &_name{
      padding: 2px 5px;
      background-color: #F1F4F8;
      font-weight: bold;
      font-size: 14px;
    }
    &_content{
      padding: 5px 10px;
    }
  }

  .receta-preview {
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    padding: 5px 10px 10px;
    label{
      font-size: 9px;
      white-space: nowrap;
      margin-bottom: 0;
    }
    .value{
      font-weight: bold;
      font-size: 12px;
    }
  }

  .informacion-general {
    font-size: 1.2em;
    margin-bottom: 15px;
  }
}
</style>
